/// <reference path="app.core.module.ts" />

module App {
    export interface IApp extends ng.IModule { }
    
    // Create the module and define its dependencies.
    export var app: IApp = angular.module('app',
        [
            App.Core.AppCore.moduleId,
            'ngAnimate',
            'mwl.calendar',
            'ngDialog'
        ]);
}